import React from 'react';
import Head from 'next/head';

export const PreloadImage: React.VFC<{ src?: string }> = ({ src }) => (
    src ? (
        <Head>
            <link rel="preload" as="image" href={src} />
        </Head>
    ) : null
);
